import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/how-to-play')({
  component: HowToPlayPage,
});

function HowToPlayPage() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 text-text">
      <h1 className="text-4xl font-bold">Cómo se juega</h1>

      <section className="mt-8 space-y-4 text-text-muted">
        <p>
          Regicide es un juego cooperativo de cartas. Los{' '}
          <strong className="text-gold">Jacks, Queens y Kings</strong> son los enemigos. Derriba los
          12 para ganar.
        </p>

        <h2 className="text-2xl font-bold text-text">Turno típico</h2>
        <ol className="list-decimal space-y-2 pl-6">
          <li>Robar 1 carta del mazo de héroes.</li>
          <li>Jugar 1, 2 o 3 cartas combinadas (poder ≤ 10).</li>
          <li>Atacar al enemigo activo o defenderte.</li>
          <li>El enemigo ataca (poder: 10 / 15 / 20).</li>
        </ol>

        <p className="mt-6">
          Ver{' '}
          <a href="/docs/GAME_RULES.md" className="text-gold underline hover:text-gold-soft">
            GAME_RULES.md
          </a>{' '}
          para las reglas completas.
        </p>
      </section>
    </main>
  );
}
